import {IBookingManagementActionCreator,IBookingManagementActionTypes} from 'models/IBookingManagementState';

const initialState:any = {
    is_api_in_request: false,
    status:null,
    message: ''
}

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
    switch (type) {
        case IBookingManagementActionTypes.CONFIRM_BOOKING_SCHEDULE_REQUEST:
            return {
                ...initialState,
                is_api_in_progress: true
            }
        case IBookingManagementActionTypes.CONFIRM_BOOKING_SCHEDULE_SUCCESS:
            return {
                ...state,
                status:200,
                message: 'Added Route successfully'
            }
        case IBookingManagementActionTypes.CONFIRM_BOOKING_SCHEDULE_FAILURE:
            return {
                ...state,
                is_api_in_progress:false,
                ...payload
            } 
        case IBookingManagementActionTypes.RESET_CONFIRM_BOOKING:
            return {
                ...initialState
            }  
        default:
            return state;
    }
};
  
  export default reducer;